var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrowseIcon03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4434 9.28532H4.40169C3.71655 9.28532 3.05947 9.56627 2.575 10.0664C2.09053 10.5665 1.81836 11.2447 1.81836 11.952V17.2853C1.81836 17.9926 2.09053 18.6708 2.575 19.1709C3.05947 19.671 3.71655 19.952 4.40169 19.952H8.27669M13.4434 17.2853H22.485C23.1702 17.2853 23.8272 17.0044 24.3117 16.5043C24.7962 16.0042 25.0684 15.3259 25.0684 14.6187V9.28532C25.0684 8.57807 24.7962 7.8998 24.3117 7.3997C23.8272 6.8996 23.1702 6.61865 22.485 6.61865H18.61",
    stroke: "#FE4A23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.27686 9.28516V3.95182C8.27686 3.24458 8.54903 2.5663 9.0335 2.0662C9.51797 1.56611 10.175 1.28516 10.8602 1.28516H16.0269C16.712 1.28516 17.3691 1.56611 17.8535 2.0662C18.338 2.5663 18.6102 3.24458 18.6102 3.95182V10.6185C18.6102 11.3257 18.338 12.004 17.8535 12.5041C17.3691 13.0042 16.712 13.2852 16.0269 13.2852H10.8602C10.175 13.2852 9.51797 13.5661 9.0335 14.0662C8.54903 14.5663 8.27686 15.2446 8.27686 15.9518V22.6185C8.27686 23.3257 8.54903 24.004 9.0335 24.5041C9.51797 25.0042 10.175 25.2852 10.8602 25.2852H16.0269C16.712 25.2852 17.3691 25.0042 17.8535 24.5041C18.338 24.004 18.6102 23.3257 18.6102 22.6185V17.2852M12.1519 5.28516V5.29849M14.7352 21.2852V21.2985",
    stroke: "#FE4A23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowseIcon03);
export default __webpack_public_path__ + "static/media/browse-icon-03.db0f5f71fbeece63508d360d6466595e.svg";
export { ForwardRef as ReactComponent };